<template>
    <div>
        <el-dialog
            title="投诉"
            @close="closeDlog(false)"
            :show-close="false"
            :close-on-click-modal="false"
            :visible.sync="dialogVisibleDialog"
            width="30%"
        >
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
            >
                <el-form-item label="原因：" prop="complainContent">
                    <el-input type="textarea" v-model="ruleForm.complainContent"></el-input>
                </el-form-item>

                <el-form-item label="凭证：" prop="complainImg">
                    <el-upload
                        action="/service-center/upload/file/single"
                        :file-list="fileList"
                        list-type="picture-card"
                        :headers="headers"
                        :on-preview="handlePictureCardPreview"
                        :on-success="handlePictureSuccess"
                        :on-remove="handleRemove"
                        :before-upload="beforeAvatarUpload"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt=""/>
                    </el-dialog>
                </el-form-item>
                <el-form-item label="联系电话：" prop="creatorPhone">
                    <el-input v-model="ruleForm.creatorPhone"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
                    <el-button @click="closeDlog">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import {saveComplain} from '../../../utils/interface';
export default {
    name: "complaintsDialog",
    data() {
        return {
            dialogVisibleDialog: false,
            ruleForm: {
                defendantUuid: "",
                orderBaseUuid: "",
                complainContent: "",
                complainImg: "",
                creatorPhone: "",
                orderNo: "",
                type: 'COMPLAIN'
            },
            fileList: [],
            rules: {
                complainContent: [
                    {
                        required: true,
                        message: "请填写投诉原因",
                        trigger: "blur",
                    },
                ],
                // imgs: [
                //   {
                //     required: true,
                //     message: "请上传凭证",
                //     trigger: "blur",
                //   },
                // ],
                creatorPhone: [
                    {
                        required: true,
                        validator: this.validatorPhone,
                        trigger: "blur",
                    },
                ],
            },
            dialogImageUrl: "",
            dialogVisible: false,
            headers: {
                Authorization: "Bearer " + $cookies.get("api_access_token"),
            },
        };
    },
    methods: {
        init(orderBaseUuid, targetUserUuid, defendant) {
            this.ruleForm.orderBaseUuid = orderBaseUuid;
            this.ruleForm.defendantUuid = targetUserUuid;
            this.ruleForm.defendant = defendant;
            this.dialogVisibleDialog = true;
        },
        closeDlog() {
            this.dialogVisibleDialog = false;
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(this.fileList.length > 0) {
                        let imgArr = [];
                        this.fileList.forEach(file => {
                            imgArr.push(file.response.url);
                        });
                        if(imgArr.length > 0) {
                            this.ruleForm.complainImg = imgArr.join(",");
                        }
                    }
                    // alert("submit!");
                    saveComplain(this.ruleForm).then((response) => {
                        if (response.success) {
                            this.$message({
                                type: "success",
                                message: "投诉提交成功",
                                duration:1200,　　//显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
                                onClose:()=>{
                                    //跳转页面或执行方法
                                    this.$router.go(0);
                                }
                            });
                        } else {
                            this.$message({
                                type: "error",
                                message: response.message,
                            });
                        }
                    });
                    this.closeDlog();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 联系方式校验
        validatorPhone(rule, value, callback) {
            if (value === "") {
                callback(new Error("请输入手机号码"));
            } else if (!this.validate.isMobile(value)) {
                callback(new Error("请输入正确的手机号码"));
            } else {
                callback();
            }
        },
        // 上传凭证照片
        handleRemove(file, fileList) {
            this.fileList = fileList;
            console.log(this.fileList);
        },
        handlePictureCardPreview(file) {
            console.log(file.url);
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handlePictureSuccess(response, file, fileList) {
            this.fileList = fileList;
            console.log(this.fileList);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type.indexOf("image") !== -1;
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.warning("上传图片只能是图片格式!");
            }
            if (!isLt2M) {
                this.$message.warning("上传图片大小不能超过 2MB!");
            }
            return isJPG && isLt2M;
        },
    },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/complaintsDialog.vue